import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import {
  NotificationPayload,
  NotificationResponse,
  GetNotificationResponse,
  NotificationParams,
} from '../../shared/model/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  sendNotification(payload: NotificationPayload): Observable<NotificationResponse> {
    const API_URL = `${this.apiUrl + ApiConstants.SEND_BROADCAST_NOTIFICATION}`;
    return this.http
      .post<NotificationResponse>(API_URL, payload)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getNotifications(notificationParam: NotificationParams): Observable<GetNotificationResponse> {
    let API_URL = `${this.apiUrl}${ApiConstants.GET_NOTIFICATION}?PageNumber=${notificationParam.pageNumber}&PageSize=${notificationParam.pageSize}`;

    if (notificationParam.sortField !== null && notificationParam.sortField !== undefined) {
      API_URL += CommonService.getQuerySingleParams('SortBy', notificationParam.sortField);
    }

    if (notificationParam.sortOrder !== null && notificationParam.sortOrder !== undefined) {
      API_URL += CommonService.getQuerySingleParams('SortOrder', notificationParam.sortOrder);
    }

    // Optional filters
    if (
      notificationParam.name !== null &&
      notificationParam.name !== undefined &&
      String(notificationParam.name) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams('Name', notificationParam.name as string);
    }

    if (
      notificationParam.phoneNumber !== null &&
      notificationParam.phoneNumber !== undefined &&
      String(notificationParam.phoneNumber) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'PhoneNumber',
        notificationParam.phoneNumber as string,
      );
    }

    if (
      notificationParam.countryId !== null &&
      notificationParam.countryId !== undefined &&
      String(notificationParam.countryId) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'CountryId',
        notificationParam.countryId as string,
      );
    }

    if (
      notificationParam.regionId !== null &&
      notificationParam.regionId !== undefined &&
      String(notificationParam.regionId) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'RegionId',
        notificationParam.regionId as string,
      );
    }

    if (
      notificationParam.createdFrom !== null &&
      notificationParam.createdFrom !== undefined &&
      String(notificationParam.createdFrom) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'CreatedFrom',
        notificationParam.createdFrom as string,
      );
    }

    if (
      notificationParam.createdTo !== null &&
      notificationParam.createdTo !== undefined &&
      String(notificationParam.createdTo) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'CreatedTo',
        notificationParam.createdTo as string,
      );
    }

    if (
      notificationParam.paymentProfileStatus !== null &&
      notificationParam.paymentProfileStatus !== undefined &&
      String(notificationParam.paymentProfileStatus) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'PaymentProfileStatus',
        notificationParam.paymentProfileStatus as string,
      );
    }

    if (
      notificationParam.userStatus !== null &&
      notificationParam.userStatus !== undefined &&
      String(notificationParam.userStatus) !== ''
    ) {
      API_URL += CommonService.getQuerySingleParams(
        'UserStatus',
        notificationParam.userStatus as string,
      );
    }

    return this.http
      .get<GetNotificationResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
